import { Box, capitalize, Typography } from "@mui/material";
import React, { FC } from "react";
import { AssociationType } from "../../../types";
import { DraggableItem } from "../../DraggableItem";

type Props = {
  association: AssociationType,
  containerId?: string,
}

export const AssociationDroppableItem: FC<Props> = ({ association: { _id, name, kinds }, containerId }) => {
  const associationName = capitalize(name.length > 40 ? name.slice(0, 40).concat("...") : name);
  const kindList = kinds && kinds.length > 0
    ? `(${kinds?.join(", ")})` : "";

  return (
    <DraggableItem id={_id} containerId={containerId}>
      <Box>
        <Box style={{
          backgroundColor: "#f8fafb",
          display: "flex",
          alignItems: "center",
          padding: "0.5rem 0.5rem",
          justifyContent: "space-between",
          borderRadius: '4px 4px 0px 0px',
        }}
        >
          <Typography variant="body2" color="primary">
            {
              `${associationName} ${kindList}`
            }
          </Typography>
        </Box>
      </Box>
    </DraggableItem>
  );
};